var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMBuzon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_buzon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buz\\xF3n_de_sugerencias",
    "data-name": "Buz\\xF3n de sugerencias"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.5,38V22.5a6.5,6.5,0,0,0-13,0V38h13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,53.84,20.83A9.18,9.18,0,0,1,54,22.5V40.1a.4.4,0,0,1-.4.4H37.5V56.1a.4.4,0,0,1-.4.4H27.9a.4.4,0,0,1-.4-.4V40.5H12.4a.4.4,0,0,1-.4-.4V22.5a9.18,9.18,0,0,1,.16-1.67L.28,32.72a.39.39,0,0,0,0,.56L32.72,65.72a.39.39,0,0,0,.56,0L65.72,33.28A.39.39,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,13.5H34V3.9a.4.4,0,0,1,.4-.4h2.11L33.28.28a.39.39,0,0,0-.56,0L19.33,13.66A9.18,9.18,0,0,1,21,13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.5,13.5H45a9.18,9.18,0,0,1,1.67.16L43.51,10.5h-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,38H51.5V22.5A6.51,6.51,0,0,0,45,16H36.5V26.5H34V16H27.21A8.94,8.94,0,0,1,30,22.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30,
    y: 40.5,
    width: 2.5,
    height: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.67,13.66l7.17,7.17A9,9,0,0,0,46.67,13.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.5,6V8H41l2.5,2.5H46.6a.4.4,0,0,0,.4-.4V3.9a.4.4,0,0,0-.4-.4H36.51L39,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.16,20.83l7.17-7.17A9,9,0,0,0,12.16,20.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.4,40.5H27.5V56.1a.4.4,0,0,0,.4.4h9.2a.4.4,0,0,0,.4-.4V40.5H53.6a.4.4,0,0,0,.4-.4V22.5a9.18,9.18,0,0,0-.16-1.67l-7.17-7.17A9.18,9.18,0,0,0,45,13.5H36.5v-3h7L41,8H36.5V6H39l-2.5-2.5H34.4a.4.4,0,0,0-.4.4v9.6H21a9.18,9.18,0,0,0-1.67.16l-7.17,7.17A9.18,9.18,0,0,0,12,22.5V40.1A.4.4,0,0,0,12.4,40.5ZM32.5,54H30V40.5h2.5ZM34,16V26.5h2.5V16H45a6.51,6.51,0,0,1,6.5,6.5V38H30V22.5A8.94,8.94,0,0,0,27.21,16ZM14.5,22.5a6.5,6.5,0,0,1,13,0V38h-13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.01,
    y: 24,
    width: 6.99,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.5,
    y: 6,
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMBuzon);
export default __webpack_public_path__ + "static/media/m_buzon.6c9551f530a524c5ce7a96f1950c2d50.svg";
export { ForwardRef as ReactComponent };